"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _selectors = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _selectors2 = require("../../store/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var getActiveValuesFromObj = function getActiveValuesFromObj(obj) {
  return R.call(R.pipe(R.toPairs, R.filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[1];
    return value;
  }), R.map(R.head)), obj);
};
var prepareHotels = function prepareHotels(hotels, categories, cities, districts, provinces
// eslint-disable-next-line max-params
) {
  return R.call(R.pipe(R.when(function () {
    return !R.isEmpty(getActiveValuesFromObj(categories));
  }, R.filter(function (_ref3) {
    var stars = _ref3.stars;
    return categories[stars];
  })), R.when(function () {
    return R.any(Boolean, [!R.isEmpty(cities), !R.isEmpty(districts), !R.isEmpty(provinces)]);
  }, R.filter(function (_ref4) {
    var cityId = _ref4.cityId,
      districtId = _ref4.districtId,
      provinceId = _ref4.provinceId;
    return R.any(Boolean, [!R.isEmpty(cities) && R.includes(cityId, cities), !R.isEmpty(districts) && R.includes(districtId, districts), !R.isEmpty(provinces) && R.includes(provinceId, provinces)]);
  })), R.sort(function (_ref5, _ref6) {
    var a = _ref5.name;
    var b = _ref6.name;
    return a.localeCompare(b, 'en');
  })), hotels);
};
var withHotelsControlProps = function withHotelsControlProps(Component) {
  var WithHotelsControlProps = function WithHotelsControlProps(_ref7) {
    var formik = _ref7.formik;
    var values = formik.values,
      setFieldValue = formik.setFieldValue;
    var countryID = values[_fn.QUERY_PARAMS.COUNTRY],
      hotelsIDs = values[_fn.QUERY_PARAMS.HOTELS],
      categories = values[_fn.QUERY_PARAMS.CATEGORY],
      cities = values[_fn.QUERY_PARAMS.CITIES],
      districts = values[_fn.QUERY_PARAMS.DISTRICTS],
      provinces = values[_fn.QUERY_PARAMS.PROVINCES],
      rating = values[_fn.QUERY_PARAMS.AVERAGE_RATING],
      services = values[_fn.QUERY_PARAMS.SERVICES];
    var handleToggleHotel = (0, _react.useCallback)(function (id) {
      return setFieldValue(_fn.QUERY_PARAMS.HOTELS, R.includes(id, hotelsIDs) ? R.without([id], hotelsIDs) : R.append(id, hotelsIDs));
    }, [hotelsIDs, setFieldValue]);
    var handleAddHotels = (0, _react.useCallback)(function (nextValue) {
      return setFieldValue(_fn.QUERY_PARAMS.HOTELS, R.concat(hotelsIDs, nextValue));
    }, [hotelsIDs, setFieldValue]);
    var handleClear = (0, _react.useCallback)(function () {
      return setFieldValue(_fn.QUERY_PARAMS.HOTELS, []);
    }, [setFieldValue]);
    var hotelsSelector = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getHotelsByCountry)(), [{
        countryID: countryID
      }]);
    }, [countryID]);
    var hotelsSelectorByParams = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getHotelsByKey)(), [{
        hotelKey: (0, _helpers.generateHotelKey)(countryID, rating, services)
      }]);
    }, [countryID, rating, services]);
    var hotels = (0, _reactRedux.useSelector)(hotelsSelector);
    var hotelsByParams = (0, _reactRedux.useSelector)(hotelsSelectorByParams);
    var loading = (0, _reactRedux.useSelector)(_selectors2.getLoadingHotels);
    var preparedHotels = (0, _react.useMemo)(function () {
      return prepareHotels(hotelsByParams, categories, cities, districts, provinces);
    }, [hotelsByParams, categories, cities, districts, provinces]);
    return /*#__PURE__*/_react.default.createElement(Component, {
      allHotels: hotels,
      countryID: countryID,
      hotels: preparedHotels,
      loading: loading,
      selectedHotelsIDs: hotelsIDs,
      onAddHotels: handleAddHotels,
      onClear: handleClear,
      onToggleHotel: handleToggleHotel
    });
  };
  return (0, _formik.connect)(WithHotelsControlProps);
};
var _default = exports.default = withHotelsControlProps;